<template>
    <div class="goodList">
        <div class="goodListBox" :style="'padding: 0 ' + item.prConfig.val + 'px;margin-top:' + item.mbConfig.val +'px;'">
            <div class="product-box type2" :class="[{'border-radius':item.bgStyle.type  == 1}]"
                 :style="item.bgColorImg.url ? 'background: url(' + item.bgColorImg.url + ')' : 'background:' + item.bgColorImg.color[0].item "
            >
                <div class="home-product">
                    <div class="search-box" v-if="item.searchShow.val">
                        <div>
                            <span>综合</span>
                        </div>
                        <div class="price-box">
                            <span>销量</span>
                            <div class="sanjiao">
                                <div class="up-sanjiao"></div>
                                <div class="down-sanjiao"></div>
                            </div>
                        </div>
                        <div class="price-box">
                            <span>价格</span>
                            <div class="sanjiao">
                                <div class="up-sanjiao"></div>
                                <div class="down-sanjiao"></div>
                            </div>
                        </div>
                    </div>
                    <div class="list-wrapper">
                        <div class="item" v-for="(i,index) in item.goodsList.list" :key="index" :style="[{'background-color': item.txtBgColor.color[0].item},{'border-radius': item.conStyle.type == 1 ? '7px': '0'}]">
                            <div class="img-box">
                                <img v-if="i.pic" :src="i.pic" :style="[{'border-radius': item.conStyle.type == 1 ? '7px': '0'}]">
                                <img v-else src="@/components/decoration/static/not_img_product.png" :style="[{'border-radius': item.conStyle.type == 1 ? '7px': '0'}]">
                            </div>
                            <div class="info" v-if="item.titleShow.val || item.opriceShow.val || item.priceShow.val">
                                <div class="product-name">
                                    <span v-if="item.titleShow.val">{{i.name}}</span>
                                    <div class="old-price" v-if="item.opriceShow.val">
                                        <span>￥{{i.oprice}}</span>
                                    </div>
                                </div>
                                <div class="price" :style="'color:' + item.fontColor.color[0].item" v-if="item.priceShow.val">
                                    <span class="mini">￥</span>
                                    <span>{{i.price}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return{

        }
    },
    props:{
        item:{
            type:Object,
            default: {}
        }
    },
    methods:{

    }
}
</script>

<style scoped lang="scss">
.goodListBox{

    .product-box{
        width: 100%;
        padding: 0 10px;
        background-repeat: no-repeat !important;
        background-size: 100% 100% !important;

        .home-product{

            .search-box{
                width: 100%;
                height: 40px;
                color: #999999;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-around;

                .price-box{
                    display: flex;
                    align-items: center;

                    .sanjiao{
                        margin-left: 2px;
                        display: flex;
                        align-items: center;
                        flex-direction: column;

                        .up-sanjiao{
                            width: 0;
                            height: 0;
                            border-top: 4px solid transparent;
                            border-right: 4px solid transparent;
                            border-left: 4px solid transparent;
                            border-bottom: 4px solid #999999;
                        }

                        .down-sanjiao{
                            width: 0;
                            height: 0;
                            margin-top: 2px;
                            border-top: 4px solid #999999;
                            border-right: 4px solid transparent;
                            border-left: 4px solid transparent;
                            border-bottom: 4px solid transparent;
                        }
                    }
                }
            }

            .list-wrapper{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                .item{
                    width: 100%;
                    margin-bottom: 10px;
                    display: flex;

                    .img-box{
                        width: 100px;
                        height: 100px;

                        img{
                            width: 100px;
                            height: 100px;
                        }
                    }

                    .info{
                        width: 220px;
                        height: 100%;
                        padding: 5px 5px;
                        margin-left: 10px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        border-bottom-left-radius: 7px;
                        border-bottom-right-radius: 7px;

                        .product-name{
                            width: 100%;
                            font-size: 16px;

                            span{
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                -webkit-box-orient: vertical;
                            }

                            .old-price{
                                color: #aaa;
                                font-size: 12px;
                                text-decoration: line-through;
                            }
                        }

                        .price{
                            font-size: 14px;
                            font-weight: 700;

                            .mini{
                                font-size: 12px;
                            }
                        }
                    }
                }
            }
        }
    }
}


.type2 {

    .home-product {

        .list-wrapper{
            display: flex;
            flex-wrap: wrap;

            .item{
                width: 160px !important;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .img-box{
                    width: 160px !important;
                    height: 160px !important;

                    img{
                        width: 160px !important;
                        height: 160px !important;
                    }
                }

                .info{
                    width: 160px !important;
                    padding: 2px 2px;
                    margin-left: 0px !important;

                    .product-name{
                        font-size: 14px !important;

                        span{
                            -webkit-line-clamp: 1 !important;
                        }
                    }
                }
            }
        }
    }
}

</style>